/* ★ PANTAU "MODEL VIDEO TIADA" selepas Run Flow (keputusan user 2026-09-24).
 *
 * Robot Flow (flow-common.js, blok "PAGAR MODEL VIDEO") menyemak model Video pilihan Control Panel
 * WUJUD dalam akaun Google Flow pelanggan SEBELUM collection dicipta. Tiada → larian berhenti, card
 * ditulis status 'flow_failed' + dua baris logs:
 *     "[Sebab] Run dihentikan: …"
 *     "[MODEL_TIADA] <model diminta> || <model SESAAT yang ada, dipisah koma>"
 * Hook ini memerhati card larian TERAKHIR (feed onSnapshot yang sudah ada — tiada bacaan tambahan) dan
 * memulangkan maklumat popup sekali sahaja.
 *
 * ⚠️ KEMBAR: format baris "[MODEL_TIADA]" ditulis dalam flow-common.js (_flowPagarModelVideo). Ubah satu = ubah dua.
 * ⚠️ logs = arrayUnion → baris SERUPA dari larian lama tidak ditambah semula tetapi masih ada dalam array.
 *    Sebab itu popup hanya dicetus oleh card larian SEMASA yang status-nya 'flow_failed' dan lastUpdated
 *    selepas Run ditekan (Run menulis 'queued_flow' dahulu, jadi flow_failed lama tidak terbawa).
 * Pemantauan tamat bila popup ditutup, atau bila Run seterusnya ditekan.
 */
import { useCallback, useState } from 'react';

const PENANDA = '[MODEL_TIADA]';

function hurai(logs) {
    if (!Array.isArray(logs)) return null;
    const baris = logs.find((l) => typeof l === 'string' && l.startsWith(PENANDA));
    if (!baris) return null;
    const [diminta, ada] = baris.slice(PENANDA.length).split('||');
    return {
        diminta: (diminta || '').trim(),
        ada: (ada || '').split(',').map((s) => s.trim()).filter(Boolean),
    };
}

function masaMs(v) {
    if (!v) return null;
    if (typeof v.toMillis === 'function') return v.toMillis();
    if (typeof v === 'number') return v;
    return null;
}

export default function usePantauModelFlow(products) {
    const [pantau, setPantau] = useState(null);   // { ids: Set, sejak: ms } — Run terakhir; null = tidak memantau

    const mulaPantau = useCallback((ids) => setPantau({ ids: new Set(ids), sejak: Date.now() }), []);
    const tutup = useCallback(() => setPantau(null), []);   // tutup = berhenti memantau Run itu

    // Diterbitkan daripada feed card — tiada effect / setState. Popup kekal sehingga ditutup.
    const cariPopup = () => {
        if (!pantau || !Array.isArray(products)) return null;
        for (const kad of products) {
            if (!kad || !pantau.ids.has(kad.id) || kad.status !== 'flow_failed') continue;
            const t = masaMs(kad.lastUpdated);
            if (t !== null && t < pantau.sejak - 60000) continue;   // tulisan lama (toleransi jam 60s)
            const h = hurai(kad.logs);
            if (!h || !h.diminta) continue;
            return { ...h, kad: [{ id: kad.id, nama: kad.name || '' }] };
        }
        return null;
    };
    const popup = cariPopup();   // murah (satu imbasan senarai card); React Compiler memoize sendiri

    return { popupModelTiada: popup, mulaPantauModel: mulaPantau, tutupPopupModel: tutup };
}
